import currency from 'currency.js';

const toCents = (num) => (num ? Math.round(currency(num) * 100) : 0) || 0;

const toCentsOrStr = (num) => {
  if (num === '' || num === undefined || num === null) return '';
  if (num === '0') return 0;
  if (+currency(num) === 0) return num;

  return Math.round(currency(num) * 100);
};

const toDollars = (num) => (num ? num / 100 : 0) || 0;

const toDollarsOrStr = (num) => (num === '' || num === undefined ? '' : isNaN(parseInt(num, 10)) ? num : num / 100);

export default { toCents, toDollars, toCentsOrStr, toDollarsOrStr };



// WEBPACK FOOTER //
// ./src/utils/currencyConversion.js